<template>
  <div class="an">
    <div class="an-title">
      <div
        class="title"
        v-for="(item, index) in msg"
        :key="item.title"
        @mouseenter="changeAn(index)"
        @click="navTo(item.href)"
      >
        <div class="title-text" :class="{ active: aim == index }">
          {{ item.title }}
        </div>
        <span class="division-line" v-if="index !== msg.length - 1">|</span>
      </div>
    </div>
    <ul class="an-list" :class="{ custom: custom }">
      <li
        v-for="(item, index) in currentList.list"
        :key="index"
        @click="getArticleInfo(item.id, item.live_url)"
      >
        <span
          class="number"
          v-if="custom"
          :style="{ background: colors[index] }"
          >{{ index + 1 }}</span
        >
        <div class="word">{{ item.title }}</div>
        <span class="time">{{ item.createtime | timestr("month") }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Announcement",
  props: ["anMsg", "custom"],
  data() {
    return {
      msg: this.anMsg || [],
      colors: ["#C52E0F", "rgba(197,46,15,0.80)", "rgba(197,46,15,0.50)"],
      aim: 0,
    };
  },
  computed: {
    currentList() {
      return this.msg ? this.msg[this.aim] : {};
    },
  },
  methods: {
    changeAn(i) {
      this.aim = i;
    },
    navTo(href) {
      this.$router.push({ path: href });
    },
    // 查看文章详情
    getArticleInfo(id, url) {
      if (url) {
        window.open(url);
      } else {
        let { href } = this.$router.resolve({
          path: `${this.msg[this.aim].href}/${id}`,
        });
        window.open(href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.an {
  background: white;
  height: 100%;
  overflow: hidden;

  .an-title {
    display: flex;
    padding-left: 16px;
    border-bottom: 1px solid #dbdbdb;
    min-height: 26px;
    font-size: 20px;

    .division-line {
      margin: 0 14px -1px 16px;
      vertical-align: text-bottom;
      color: #bdbdbd;
    }

    .title {
      display: flex;
      color: #888888;
      letter-spacing: 0.57px;
      text-align: center;
      margin: 0 0 -1.5px;

      cursor: pointer !important;
    }

    .title-text.active {
      font-size: 20px;
      padding-bottom: 15px;
      color: #c52e0f;
      letter-spacing: 0.57px;
      text-align: center;
      border-bottom: 2px solid #c52e0f;
    }
  }

  .an-list {
    padding-left: 18px;
    color: #d8d8d8;

    &.custom {
      list-style: none;
      padding-left: 28px;
    }

    li {
      border-bottom: 1px dashed #f3f3f3;
      height: 41px;
      line-height: 41px;
      position: relative;
      cursor: pointer !important;

      .number {
        width: 18px;
        height: 18px;
        background: #cacaca;
        position: absolute;
        top: 12px;
        left: -28px;
        border-radius: 3px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 18px;
      }

      .word {
        position: absolute;
        width: 80%;
        top: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 80px;
        font-size: 16px;
        color: #3a3a3a;
        letter-spacing: 0.46px;

        &:hover {
          color: #c52e0f;
        }
      }

      .time {
        position: absolute;
        width: 80px;
        top: 0;
        right: 0;
        text-align: right;
        padding-right: 3px;
        font-size: 15px;
        color: #bdbdbd;
        letter-spacing: 0.43px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Announcement.vue